import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { getUserFromStorage } from '../../utils/auth';
import AgentTable from '../../components/AgentTable';

const AgentPage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = getUserFromStorage();
    if (storedUser?.role === 'admin') {
      setUser(storedUser);
    } else {
      navigate('/login'); // ✅ redirect if not admin
    }
  }, [navigate]);

  if (!user) return null;

  return (
    <DashboardLayout role="admin">
      <AgentTable user={user} />
    </DashboardLayout>
  );
};

export default AgentPage;
